<div [formGroup]="form" class="dynamic-form">
    <span class="form-group my-2">
        <label for="float-input" class=" label-control">{{ field['label'] }}</label>
        <p-radioButton id="float-input" [value]="field['value']" [formControlName]="field['name']">
        </p-radioButton>
    </span>
</div>